import React from 'react';

import { Modal, ModalCloseButton, ModalContent, ModalHeading, ModalProps } from '@uikit';

export const CountryRestrictedModal = (props: Omit<ModalProps, 'children'>) => {
  return (
    <Modal {...props}>
      <ModalContent className="flex flex-col items-center p-6 sm:px-12  w-full max-w-[472px]">
        <ModalCloseButton className="!mb-3" />

        <ModalHeading className="mb-4">Oops!</ModalHeading>

        <p className="text-neutral-400 mb-8 text-center">
          Unfortunately, the project does not allow residents of your country to participate in its
          sale.
        </p>

        <button
          className="button button-solid-secondary button-lg w-full"
          onClick={() => {
            props.onOpenChange?.(false);
          }}
        >
          Ok
        </button>
      </ModalContent>
    </Modal>
  );
};

export default CountryRestrictedModal;
